"use client"
import { twMerge } from "tailwind-merge"
import { BodyDefaultLight, Heading3 } from "../text"
import TextLink from "../text/TextLink"
import EmbedButton from "../typeform/EmbedButton"

interface ContactFormProps extends React.HTMLAttributes<HTMLDivElement> {
  showHeader?: boolean
  headerTextTitle?: string
}

const ContactForm: React.FC<ContactFormProps> = ({
  showHeader = false,
  headerTextTitle = "Staat jouw vraag er niet tussen?",
  className,
  ...divProps
}) => {
  return (
    <>
      {showHeader && (
        <div className={twMerge("mx-auto max-w-lg text-center pb-6", className)} {...divProps}>
          <Heading3 className="mb-6">{headerTextTitle}</Heading3>
          <BodyDefaultLight>
            Neem dan contact op via&nbsp;
            <TextLink href="mailto:hello@goodshift.nl">hello@goodshift.nl</TextLink>
            &nbsp;of vul het contactformulier in.
          </BodyDefaultLight>
        </div>
      )}

      <EmbedButton id="XOS3vtvY" className="mx-auto w-[200px] block">
        Contact
      </EmbedButton>
    </>
  )
}

export default ContactForm
